import React from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0A0F1C] flex items-center justify-center p-6">
      <div className="w-full max-w-2xl text-center">
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[180px] font-bold text-gray-800/50">404</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search className="h-32 w-32 text-blue-500/50" />
          </div>
        </div>

        {/* Content */}
        <h1 className="text-3xl font-bold text-white mb-3">Page Not Found</h1>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved. 
          Please check the URL or navigate back to the dashboard.
        </p>

        {/* Actions */}
        <div className="flex items-center justify-center space-x-4">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="space-x-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Go Back</span>
          </Button>
          
          <Link to="/">
            <Button className="space-x-2">
              <Home className="h-4 w-4" />
              <span>Return Home</span>
            </Button>
          </Link>
        </div>

        {/* Help Link */}
        <div className="mt-8 text-sm text-gray-500">
          Need help? <a href="#" className="text-blue-500 hover:text-blue-400">Contact support</a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;